export default "__VITE_ASSET__931b243a__"